import { CLOSE_EOD_SHIPMENTS, CLOSE_EOD_SHIPMENTS_FAILURE, CLOSE_EOD_SHIPMENTS_SUCCESS } from './shipments.eod.actions';

const initialState = {
  hasErrors: false,
};

export const shipmentsEOD = (state = initialState, action) => {
  switch (action.type) {
    case CLOSE_EOD_SHIPMENTS:
      return {
        ...state,
        hasErrors: false,
      };
    case CLOSE_EOD_SHIPMENTS_FAILURE:
      if (!action.messageGuid) {
        return {
          ...state,
          hasErrors: true,
        };
      }
      return {
        ...state,
        hasErrors: true,
        [action.messageGuid]: {
          errors: [action.error],
        },
      };
    case CLOSE_EOD_SHIPMENTS_SUCCESS:
      return {
        ...state,
        [action.messageGuid]: action.pusherData,
      };
    default:
      return state;
  }
};

export { namespace } from './shipments.eod.reducer.metadata';
